import { useEffect, useMemo, useState } from "react";

const DEFAULT_HERO = "https://images.unsplash.com/photo-1746458258536-b9ee5db20a73?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBob3VzZSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2OTcyMDE0MXww&ixlib=rb-4.1.0&q=85";

/**
 * Random-order rotating background for the homepage hero.
 * - Picks a random shuffle on mount (so all visitors see a fresh sequence)
 * - Fades between images every 6 seconds
 * - Falls back to the default image if no gallery configured
 */
export default function HeroBackground({ gallery, intervalMs = 6000 }) {
  const images = useMemo(() => {
    const arr = Array.isArray(gallery) && gallery.length > 0 ? [...gallery] : [DEFAULT_HERO];
    // Fisher–Yates shuffle for random order
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }, [gallery]);

  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return;
    const id = setInterval(() => {
      setActiveIdx((i) => (i + 1) % images.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [images, intervalMs]);

  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-background">
      {images.map((src, idx) => (
        <div
          key={`${src}-${idx}`}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out"
          style={{
            backgroundImage: `url('${src}')`,
            opacity: idx === activeIdx ? 1 : 0,
          }}
        />
      ))}
    </div>
  );
}
